import { FormProps } from "./FormProps";

interface InputFormProps extends FormProps {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  autoComplete?: string;
}

const InputForm: React.FC<InputFormProps> = ({
  label,
  name,
  id,
  type,
  leadingIcon,
  value,
  onChange,
  endingIcon,
  className,
  required = false,
  readOnly = false,
  styleLabel,
  autoComplete = "off",
  ...props
}) => {
  const inputPaddingLeft = leadingIcon ? "pl-10" : "pl-3";
  const inputPaddingRight = endingIcon ? "pr-10" : "pr-3";

  return (
    <div className="w-full mb-3">
      <label
        htmlFor={id}
        className={` ${styleLabel || "block text-sm/6 font-medium text-left"}`}
      >
        {label}
      </label>
      <div className="relative remove-arrow">
        <input
          placeholder={`Enter ${label?.toLowerCase()}`}
          name={name}
          id={id}
          type={type}
          value={value === null || value === 0 ? "" : value}
          onChange={onChange}
          required={required}
          readOnly={readOnly}
          autoComplete={autoComplete}
          {...props}
          className={`w-full grow py-2 ${inputPaddingLeft} ${inputPaddingRight} truncate border-[1px] text-base placeholder:text-gray-400 sm:text-sm/6 border-primary-900 shadow-sm border-opacity-50 rounded-lg [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ${className}`}
        />
        {leadingIcon && (
          <span className="absolute top-1/2 left-3 -translate-y-1/2">
            {leadingIcon}
          </span>
        )}
        {endingIcon && (
          <span className="absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer">
            {endingIcon}
          </span>
        )}
      </div>
    </div>
  );
};

export default InputForm;
